import { render, staticRenderFns } from "./uatTesting.vue?vue&type=template&id=2cbfa8ac&"
import script from "./uatTesting.vue?vue&type=script&lang=js&"
export * from "./uatTesting.vue?vue&type=script&lang=js&"
import style0 from "./uatTesting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports